import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const Contact = () => {
  return (
    <Container>
      <h1>Contact Us</h1>
      <p>Get in touch with Luke, Patty, and Dobby!</p>
    </Container>
  );
};

export default Contact;
